import React, { useState, useEffect } from 'react'
import { useForm, Controller } from 'react-hook-form'
import SidebarProposal from '../../../layouts/sidebarProposal/SidebarProposal'
import ErrorWidget from '../../../widgets/errorWidget/ErrorWidget'
import PanalLoadingTemplate from '../../../widgets/loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'
import ContentHeader from '../../../components/ContentHeader/ContentHeader'
import ExpenditBreakdownByActivitiesWidget from '../../../widgets/periodicFinancialReportSubProject/ExpenditBreakdownByActivitiesWidget'
import SummaryPeriodicExpensesWidget from '../../../widgets/periodicFinancialReportSubProject/SummaryPeriodicExpensesWidget'
import {
  Button,
  Col,
  ControlLabel,
  Icon,
  IconButton,
  Message,
  Modal,
  Panel,
  Radio,
  RadioGroup,
  Row,
  Uploader,
} from 'rsuite'
import SaveButton from '../../../components/buttons/saveButton/SaveButton'
import {
  DEFAULT_ERR_MSG,
  RETRY_CONTACT_ADMIN,
  SAVE_FAILED_MSG,
  SAVE_SUCCESS_MSG,
} from '../../../constants/msgText'
import PdfRenderWidgets from '../../../widgets/pdfWidgets/PdfRenderWidgets'
import ConfirmWidget from '../../../widgets/confirm/ConfirmWidget'
import InputForm from '../../../components/forms/input/InputForm'
import EditButton from '../../../components/buttons/editButton/EditButton'
import classNames from 'classnames'
import AppContext from '../../../context/AppContext'
import ErrorMessage from '../../../components/message/errorMessage/ErrorMessage'
import { isImageOrPdf, isRequired, isValidators } from '../../../utils/ValidatorUtils'
import {
  getDowloadSubProjectFilePath,
  getFinancialReport,
  getFinancialReportRefreshPage,
  getProgressFinancialPdf,
  saveApproveInstallmentDisbursement,
  saveFinancialReportSendBlack,
  saveRequestingDisbursement,
  saveTransferInstallmentPayment,
} from '../../../redux/actions/subProjectFinancialReport'
import { doneLoading, startLoading } from '../../../utils/loading'
import notification from '../../../utils/notification'
import { isEmpty } from 'lodash-es'
import OverlayLoader from '../../../components/OverlayLoader/OverlayLoader'
import { sessionGetItemStr } from '../../../utils/sessionHelpers'
import { useParams, useHistory } from 'react-router-dom'
import pathname from '../../../constants/pathname'
import SubProjectViewFilesWidget from '../../../widgets/periodicFinancialReportSubProject/SubProjectViewFilesWidget'
import { getValueFromOptions } from '../../../utils/dataUtil'
import CKEditorBlankFrom from '../../../components/forms/input/CKEditorBlankFrom'

export default function PeriodicFinancialReportClose() {
  const { register, handleSubmit, errors, control, setValue, getValues, clearErrors } = useForm()
  const [error, setError] = useState()
  const [schemas, setSchemas] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const [isPdfError, setIsPdfError] = useState(false)
  const [previewPdf, setPreviewPdf] = useState()
  const [isLoadingPDF, setIsLoadingPDF] = useState(false)
  const [showVerifyConfirm, setShowVerifyConfirm] = useState(false)

  const [showTransferInstallmentPaymentConfirm, setShowTransferInstallmentPaymentConfirm] =
    useState(false)
  const { theme } = React.useContext(AppContext)
  const [showApproveConfirm, setShowApproveConfirm] = useState(false)
  const [showWithdrawConfirm, setShowWithdrawConfirm] = useState(false)
  const [approveTypeVal, setApproveTypeVal] = useState(null)
  const [approveWithdrawTypeVal, setApproveWithdrawTypeVal] = useState(null)
  const [show, setShow] = useState(false)
  const [isError, setIsError] = useState()
  const [fileTypeError, setFileTypeError] = useState(false)
  const [electronicSignature, setElectronicSignature] = useState(null)
  const [statusUpdate, SetStatusUpdate] = useState(false)
  const [sendToSup, setSendToSup] = useState(false)

  const defaultSupportType = '.jpg, .jpeg, .png, .pdf'
  const defaultMaxFileSize = 5
  let installmentPlanId = sessionStorage.getItem('param')?.substring(1)
  const history = useHistory()

  const projectCode = null,
    projectVersionId = sessionGetItemStr('projectId'),
    period = 0

  const endFileName = 'แนบแบบสรุปขอสิ้นสุดโครงการ'

  let progressId = sessionStorage.getItem('param')?.substring(1)

  useEffect(() => {
    console.log('progressId', progressId)

    console.log('progressId => ', progressId)

    handleGetSchema()
    setPreviewPdf()
  }, [progressId])

  const handleGetSchema = async () => {
    setIsLoading(true)
    startLoading()
    try {
      const _schema = await getFinancialReport(
        period,
        projectCode,
        projectVersionId,
        installmentPlanId
      )

      setSchemas(_schema)
    } catch (e) {
      console.log('error', e)
      if (e?.response?.data) {
        setError({
          statusCode: e.response.data.status,
          errorMessage: e.response.data.errors?.message,
        })
      } else {
        setError({})
      }
    }
    doneLoading()
    setIsLoading(false)
  }

  const handleGetReport = async () => {
    console.log('handleGetReport', schemas)
    // setIsLoading(true)
    setIsPdfError(false)
    setIsLoadingPDF(true)

    // console.log(projectCode, period)

    try {
      const response = await getProgressFinancialPdf(schemas.projectCode, schemas.period)
      console.log('response preview pdf', response)
      if (response) {
        setPreviewPdf(response)
        setIsPdfError(false)
      } else {
        setIsPdfError(true)
      }
    } catch (e) {
      console.error('error pdf => ', e)
      setIsPdfError(true)
    }

    // doneLoading()
    // setIsLoading(false)
    setIsLoadingPDF(false)
  }

  const onSubmitSendBlack = async (data) => {
    console.log('onSubmitSendBlack => ', data)
    setIsLoading(true)
    startLoading()

    try {
      const request = {
        projectVersionId: schemas.projectVersionId,
        projectCode: schemas.projectCode,
        period: schemas.period,
        installmentPlanDetailId: installmentPlanId,
        progressReportsId: schemas?.progressReportsId || null,
        approveComment: data?.notedInput || '',
        sendToSup: sendToSup
      }

      let response = await saveFinancialReportSendBlack(request)

      if (response) {
        notification.open('success', {
          title: SAVE_SUCCESS_MSG,
        })
        handleGetSchema()
        setShowVerifyConfirm(false)
      } else {
        setIsError(true)
      }
    } catch (e) {
      console.log('error', e)

      if (e?.response?.data) {
        console.log(e?.response?.data)
        setIsError(e?.response?.data?.errorMessage || DEFAULT_ERR_MSG)
        notification.open('error', {
          title: e?.response?.data?.errorMessage || DEFAULT_ERR_MSG,
        })
      } else {
        setIsError(DEFAULT_ERR_MSG)
      }
    }

    doneLoading()
    setIsLoading(false)
  }

  const onSubmitTranInstallPayment = async (data) => {
    console.log('onSubmitTranInstallPayment => ', data)

    setIsLoading(true)
    startLoading()

    try {
      const formData = new FormData()
      formData.append('ProjectVersionId', schemas.projectVersionId || '')
      formData.append('ProjectCode', schemas.projectCode || '')
      formData.append('Period', schemas.period || 0)
      formData.append('InstallmentPlanDetailId', installmentPlanId || '')

      formData.append('ProgressReportsId', schemas?.progressReportsId || null || '')
      data.attachFiles &&
        data.attachFiles?.forEach((element) => {
          formData.append('FinancialFile', element.blobFile)
        })

      let response = await saveTransferInstallmentPayment(formData)

      if (response) {
        notification.open('success', {
          title: SAVE_SUCCESS_MSG,
        })
        handleGetSchema()
        setShowTransferInstallmentPaymentConfirm(false)
      } else {
        setIsError(true)
      }
    } catch (e) {
      console.log('error', e)
      if (e?.response?.data) {
        console.log(e?.response?.data)
        setIsError(e?.response?.data?.errorMessage || DEFAULT_ERR_MSG)
        notification.open('error', {
          title: e?.response?.data?.errorMessage || DEFAULT_ERR_MSG,
        })
      } else {
        setIsError(DEFAULT_ERR_MSG)
      }
    }

    doneLoading()
    setIsLoading(false)
  }

  const onSubmitRequestInstallmentPayment = async (data) => {
    console.log('onSubmitRequestInstallmentPayment => ', data)

    // return false

    // if (!approveWithdrawTypeVal) {
    //   console.log('goooii')
    //   setShow(true)
    //   return false
    //   // approveTypeVal(null)
    // }

    setIsLoading(true)
    startLoading()

    try {
      const formData = new FormData()
      formData.append('ProjectVersionId', schemas.projectVersionId || '')
      formData.append('ProjectCode', schemas.projectCode || '')
      formData.append('Period', schemas.period || 0)
      formData.append('InstallmentPlanDetailId', installmentPlanId || '')
      formData.append('ProgressReportsId', schemas?.progressReportsId || '')
      formData.append('ApproveType', data?.approveType || '0')
      formData.append('ApproveComment', data?.notedInput || '')
      formData.append('WorkSummary', data?.workSummary || '')

      data.attachFiles &&
        data.attachFiles?.forEach((element) => {
          formData.append('FileEndProject', element.blobFile)
        })

      let response = await saveRequestingDisbursement(formData)

      if (response) {
        notification.open('success', {
          title: SAVE_SUCCESS_MSG,
        })
        handleGetSchema()
        setShowWithdrawConfirm(false)
      } else {
        setIsError(true)
      }
    } catch (e) {
      console.log('error', e)
      if (e?.response?.data) {
        console.log(e?.response?.data)
        setIsError(e?.response?.data?.errorMessage || DEFAULT_ERR_MSG)
        notification.open('error', {
          title: e?.response?.data?.errorMessage || DEFAULT_ERR_MSG,
        })
      } else {
        setIsError(DEFAULT_ERR_MSG)
      }
    }

    doneLoading()
    setIsLoading(false)
  }

  const onSubmitApproveInstallmentPayment = async (data) => {
    console.log('onSubmitApproveInstallmentPayment => ', data)

    // console.log('schemas => ', schemas.period)

    setIsLoading(true)
    startLoading()

    try {
      const request = {
        projectVersionId: schemas.projectVersionId,
        projectCode: schemas.projectCode,
        period: schemas.period,
        installmentPlanDetailId: installmentPlanId,
        progressReportsId: schemas?.progressReportsId || null,
        approveType: data?.approveType || '0',
        financialSigning: schemas.isNotReportsProgress == 1 ? 1 : data.financialSigning, //อนุมัติเบิกงวดที่ 1 ไม่ต้องมี ให้เลือก กระดาษ หรือ อิเล็กทรอนิกส์ แต่ต้อง def เป็นกระดาษ = 1
        approveComment: data.notedInput,
      }

      // console.log('request => ', request)

      // return false

      let response = await saveApproveInstallmentDisbursement(request)

      if (response) {
        notification.open('success', {
          title: SAVE_SUCCESS_MSG,
        })
        handleGetSchema()
        setShowApproveConfirm(false)

        return history.push(
          //  `${pathname.subProject.overviewSubProject}/${response.model.newProjectVersionId}`
          `${pathname.subProject.overviewSubProject}`
        )
      } else {
        setIsError(true)
      }
    } catch (e) {
      console.log('error', e)
      if (e?.response?.data) {
        console.log(e?.response?.data)
        setIsError(e?.response?.data?.errorMessage || DEFAULT_ERR_MSG)
        notification.open('error', {
          title: e?.response?.data?.errorMessage || DEFAULT_ERR_MSG,
        })
      } else {
        setIsError(DEFAULT_ERR_MSG)
      }
    }

    doneLoading()
    setIsLoading(false)
  }

  const handleResetSchema = (status) => {
    console.log('handleResetSchema => ', status)
    if (status) {
      handleGetSchema()
    }
  }

  const handleResetSchemaPeriod1 = (status) => {
    console.log('handleResetSchema => ', status)
    if (status && schemas.isNotReportsProgress == 1) {
      handleGetSchema()
    }
  }

  const handlePreviewFile = async (fileObj) => {
    console.log('handlePreviewFile => ', fileObj)

    startLoading()
    var file = await getDowloadSubProjectFilePath(fileObj.path)
    const url = window.URL.createObjectURL(new Blob([file], { type: file.type }))
    const link = document.createElement('a')
    link.href = url
    link.target = '_blank'
    link.setAttribute('value', fileObj.name)
    document.body.appendChild(link)
    link.click()
    doneLoading()
  }

  const handleDownloadFile = async (fileObj) => {
    console.log('handleDownloadFile => ', fileObj)

    startLoading()
    var file = await getDowloadSubProjectFilePath(fileObj.path)
    const url = window.URL.createObjectURL(new Blob([file], { type: file.type }))
    const link = document.createElement('a')
    link.href = url
    link.setAttribute('download', fileObj?.name || 'สำเนาสมุดบัญชีเงินฝากธนาคาร')
    document.body.appendChild(link)
    link.click()
    doneLoading()
  }

  if (error) {
    return (
      <SidebarProposal isSubProjectDep6>
        <ErrorWidget statusCode={error.statusCode} errorMessage={error.errorMessage} />
      </SidebarProposal>
    )
  }

  if (!schemas || isLoading) {
    return (
      <SidebarProposal isSubProjectDep6>
        <OverlayLoader />
        <PanalLoadingTemplate />
      </SidebarProposal>
    )
  }

  console.log('isLoading => ', isLoading)

  return (
    <>
      {/* {isLoading && <OverlayLoader />} */}
      {isLoadingPDF && <OverlayLoader />}

      <SidebarProposal isSubProjectDep6>
        <ContentHeader header={schemas.header} subHeader={schemas.subHeader} isNotCallApi />

        {schemas.message.desc && (
          <>
            <div style={{ marginBottom: 10 }}>
              <Panel shaded bordered bodyFill>
                <Message
                  type={schemas.message.type}
                  description={<div dangerouslySetInnerHTML={{ __html: schemas.message.desc }} />}
                />
              </Panel>
            </div>
          </>
        )}

        {/* schemas.forms.button.buttonApproveInstallmentPayment */}

        <ExpenditBreakdownByActivitiesWidget
          schema={schemas.forms.projectActivity}
          period={schemas.period}
          projectCode={schemas.projectCode}
          projectVersionId={schemas.projectVersionId}
          disabled={schemas.disabled}
          installmentPlanId={installmentPlanId}
          statusOnSave={handleResetSchema}
        />

        <br />

        <SummaryPeriodicExpensesWidget
          schema={schemas.forms.summaryPeriodicExpenses}
          period={schemas.period}
          projectCode={schemas.projectCode}
          projectVersionId={schemas.projectVersionId}
          // disabled={!!schemas.financialReportId}
          disabled={schemas.isNotReportsProgress == 1 ? true : !!schemas.financialReportId}
          formsDisabled={schemas.disabled}
          projectActivitySchema={schemas?.forms?.projectActivity}
          installmentPlanId={installmentPlanId}
          financialReportId={schemas.financialReportId}
          statusOnSave={handleResetSchemaPeriod1}
          isNotReportsProgress={schemas.isNotReportsProgress}
        />

        <br />

        {/* <ConfirmWidget
          size="md"
          title={`ยืนยัน${schemas.forms.button.buttonApprove}`}
          show={showVerifyConfirm}
          detail={`กรุณาระบุข้อความเพื่อขอส่งรายงาน และเบิกเงินงวด กับทีมสนับสนุน (ถ้ามี)`}
          onCancle={() => setShowVerifyConfirm(false)}
          onConfirm={() => {
            setShowVerifyConfirm(false)
            // handleProposalProjectSubmitVerify(request)
          }}
        /> */}

        <br />

        {isPdfError ? (
          <Message showIcon type="error" description={'ไม่พบไฟล์ PDF  ' + RETRY_CONTACT_ADMIN} />
        ) : (
          <>
            <div style={{ marginTop: -40 }}>
              {schemas.displayPdf && schemas.isNotReportsProgress != 1 && (
                <PdfRenderWidgets
                  file={previewPdf}
                  isLoading={isLoadingPDF}
                  isShaded={true}
                  onReload={() => handleGetReport()}
                  loadingMessage="กรุณารอสักครู่ ระบบกำลังสร้าง PDF ข้อเสนอโครงการ..."
                  firstExpandToReload
                />
              )}
            </div>
          </>
        )}

        {/* {schemas.forms.button && ( */}
        {(schemas?.forms?.button?.buttonRequestInstallmentPayment ||
          schemas?.forms?.button?.buttonApproveInstallmentPayment ||
          schemas.forms.button.buttonTransferInstallmentPayment ||
          schemas.forms.button.buttonSendBlack) && (
          <>
            <div
              style={{
                zIndex: 101,
                position: 'sticky',
                bottom: 0,
                left: 0,
                width: '100%',
                textAlign: 'right',
                marginTop: 20,
              }}
            >
              <Panel shaded bodyFill>
                <div style={{ marginTop: 10, textAlign: 'center' }}>
                  {/* ส่งรายงานขอเบิกเงินงวด */}
                  {schemas.forms.button.buttonRequestInstallmentPayment && (
                    <>
                      <SaveButton
                        icon="send"
                        disabled={!schemas.financialReportId}
                        onClick={() => {
                          setApproveWithdrawTypeVal(
                            schemas?.forms?.buttonRequestInstallmentPayment?.approveType?.value ||
                              null
                          )
                          setShowWithdrawConfirm(true)
                          setShow(false)
                          // setApproveWithdrawTypeVal(null)
                        }}
                      >
                        {schemas.forms.button.buttonRequestInstallmentPayment}
                      </SaveButton>
                    </>
                  )}

                  {/* อนุมัติเบิกเงินงวด */}
                  {schemas.forms.button.buttonApproveInstallmentPayment && (
                    <>
                      <SaveButton
                        icon="send"
                        disabled={!schemas.financialReportId}
                        onClick={() => {
                          setShowApproveConfirm(true)
                          setShow(false)
                          setApproveTypeVal(null)
                        }}
                      >
                        {schemas.forms.button.buttonApproveInstallmentPayment}
                      </SaveButton>
                    </>
                  )}

                  {/* โอนจ่ายเงินงวด */}
                  {schemas.forms.button.buttonTransferInstallmentPayment && (
                    <>
                      <SaveButton
                        disabled={!schemas.financialReportId}
                        onClick={() => {
                          setShowTransferInstallmentPaymentConfirm(true)
                        }}
                        icon="exchange"
                      >
                        {schemas.forms.button.buttonTransferInstallmentPayment}
                      </SaveButton>
                    </>
                  )}

                  {/* {schemas.forms.button.buttonApprove && (
                    <>
                      <IconButton
                        appearance="ghost"
                        disabled={!schemas.financialReportId}
                        style={{
                          marginRight: 10,
                          marginBottom: 10,
                        }}
                        icon={
                          <Icon appearance="ghost" icon={'send'} className="bt-gost-icon-radius" />
                        }
                        onClick={() => {}}
                      >
                        {schemas.forms.button.buttonApprove} หน้าของภาคี
                      </IconButton>
                    </>
                  )} */}

                  {/* ส่งกลับแก้ไข ถึง ผู้รับทุน */}
                  {schemas.forms.button.buttonSendBlack && (
                    <>
                      <EditButton
                        icon="send"
                        disabled={!schemas.financialReportId}
                        onClick={() => {
                          setShowVerifyConfirm(true)
                          setSendToSup(false)
                        }}
                        // disabled={isLoading}
                      >
                        {schemas.forms.button.buttonSendBlack}
                      </EditButton>
                    </>
                  )}

                  {/* ส่งกลับแก้ไข ถึง พี่เลี้ยง */}
                  {schemas.forms.button.buttonSendBlackSup && (
                    <>
                      <EditButton
                        icon="send"
                        onClick={() => {
                          setShowVerifyConfirm(true)
                          setSendToSup(true)
                        }}
                        // disabled={isLoading}
                      >
                        {schemas.forms.button.buttonSendBlackSup}
                      </EditButton>
                    </>
                  )}
                </div>
              </Panel>
            </div>
          </>
        )}

        {/* ส่งรายงานขอเบิกเงินงวด */}
        <Modal
          show={showWithdrawConfirm}
          onHide={() => {
            // setShowVerifyConfirm(false)
            // setShowTransferInstallmentPaymentConfirm(false)
            setShowWithdrawConfirm(false)
          }}
          size="lg"
        >
          <Modal.Header>
            <Modal.Title></Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div style={{ padding: 30 }}>
              {schemas.forms.buttonRequestInstallmentPayment && (
                <>
                  {schemas.isNotReportsProgress != 1 ? (
                    <Row style={{ marginTop: 40 }}>
                      <Col lg={2} md={2} sm={2} xs={2}></Col>
                      <Col lg={20} md={20} sm={20} xs={20}>
                        {/* {show && <Message showIcon type="error" description="กรุณาเลือก 1 รายการ" />} */}
                        <ErrorMessage
                          error={
                            errors[schemas.forms.buttonRequestInstallmentPayment.approveType.name]
                          }
                        />

                        <Controller
                          name={schemas.forms.buttonRequestInstallmentPayment.approveType.name}
                          control={control}
                          defaultValue={
                            schemas.forms.buttonRequestInstallmentPayment.approveType.value || null
                          }
                          rules={isValidators(
                            schemas.forms.buttonRequestInstallmentPayment.approveType.validators
                          )}
                          render={(props) => {
                            return (
                              <RadioGroup
                                value={props.value}
                                onChange={(value) => {
                                  props.onChange(value)
                                  setApproveWithdrawTypeVal(value)
                                  setShow(false)
                                }}
                              >
                                {schemas.forms.buttonRequestInstallmentPayment.approveType.options.map(
                                  (item) => (
                                    <Radio
                                      key={item.value}
                                      value={item.value}
                                      disabled={
                                        schemas.forms.buttonRequestInstallmentPayment.approveType
                                          .disabled
                                      }
                                    >
                                      {item.label}
                                    </Radio>
                                  )
                                )}
                              </RadioGroup>
                            )
                          }}
                        />
                      </Col>
                      <Col lg={2} md={2} sm={2} xs={2}></Col>
                    </Row>
                  ) : (
                    <>
                      <Row style={{ marginTop: 40 }}>
                        <Col lg={2} md={2} sm={2} xs={2}></Col>
                        <Col lg={20} md={20} sm={20} xs={20}>
                          <b style={{ textIndent: '2.5em' }}>
                            {getValueFromOptions(
                              schemas.forms.buttonRequestInstallmentPayment.approveType.options,
                              schemas.forms.buttonRequestInstallmentPayment.approveType.value
                            ) || ''}
                          </b>
                        </Col>
                        <Col lg={2} md={2} sm={2} xs={2}></Col>
                      </Row>
                    </>
                  )}

                  <Row style={{ marginTop: 20 }}>
                    <Col lg={2} md={2} sm={2} xs={2}></Col>
                    <Col lg={20} md={20} sm={20} xs={20}>
                      <div style={{ padding: 8 }}>
                        <CKEditorBlankFrom
                          schema={schemas.forms.buttonRequestInstallmentPayment.notedInput}
                          // value={item?.actualResults?.value || ''}
                          name={`${schemas.forms.buttonRequestInstallmentPayment.notedInput.name}`}
                          register={register}
                          Controller={Controller}
                          control={control}
                          errors={errors}
                          setValue={setValue}
                          clearErrors={clearErrors}
                          hideToolbar={true}
                          noControlLabel={false}
                          marginTopRow={'unset'}
                          // disable={schemas.forms.buttonRequestInstallmentPayment.workSummary.disable}
                        />
                      </div>
                      {/* <InputForm
                        schema={schemas.forms.buttonRequestInstallmentPayment.notedInput}
                        // value={item.link}
                        register={register}
                        // placeholder={schemas.otherExpensesInput.placeholder}
                        Controller={Controller}
                        control={control}
                        errors={errors}
                        setValue={setValue}
                        clearErrors={clearErrors}
                        // hideLabel={true}
                        componentClass={'textarea'}
                      /> */}
                    </Col>
                    <Col lg={2} md={2} sm={2} xs={2}></Col>
                  </Row>

                  {(approveWithdrawTypeVal == 1 || approveWithdrawTypeVal == 2) && (
                    <>
                      <Row style={{ marginTop: 20 }}>
                        <Col lg={2} md={2} sm={2} xs={2}></Col>
                        <Col lg={20} md={20} sm={20} xs={20}>
                          <div style={{ padding: 8 }}>
                            <CKEditorBlankFrom
                              schema={schemas.forms.buttonRequestInstallmentPayment.workSummary}
                              // value={item?.actualResults?.value || ''}
                              name={`${schemas.forms.buttonRequestInstallmentPayment.workSummary.name}`}
                              register={register}
                              Controller={Controller}
                              control={control}
                              errors={errors}
                              setValue={setValue}
                              clearErrors={clearErrors}
                              hideToolbar={true}
                              noControlLabel={false}
                              marginTopRow={'unset'}
                              // disable={schemas.forms.buttonRequestInstallmentPayment.workSummary.disable}
                            />
                          </div>

                          {/* <InputForm
                            schema={schemas.forms.buttonRequestInstallmentPayment.workSummary}
                            // value={item.link}
                            register={register}
                            // placeholder={schemas.otherExpensesInput.placeholder}
                            Controller={Controller}
                            control={control}
                            errors={errors}
                            setValue={setValue}
                            clearErrors={clearErrors}
                            // hideLabel={true}
                            componentClass={'textarea'}
                          /> */}
                        </Col>
                        <Col lg={2} md={2} sm={2} xs={2}></Col>
                      </Row>
                      <Row style={{ marginTop: 40 }}>
                        <Col lg={2} md={2} sm={2} xs={2}></Col>
                        <Col lg={20} md={20} sm={20} xs={20}>
                          <ErrorMessage
                            error={
                              errors[schemas.forms.buttonRequestInstallmentPayment.attachFiles.name]
                            }
                          />

                          <p>{endFileName}</p>
                          <Controller
                            key={schemas.forms.buttonRequestInstallmentPayment.attachFiles.name}
                            name={schemas.forms.buttonRequestInstallmentPayment.attachFiles.name}
                            control={control}
                            rules={isValidators(
                              schemas.forms.buttonRequestInstallmentPayment.attachFiles.validators
                            )}
                            defaultValue={''}
                            render={(props) => {
                              return (
                                <Uploader
                                  accept={
                                    schemas.forms.buttonRequestInstallmentPayment.attachFiles
                                      .fileType || '.jpg, .jpeg, .png, .pdf'
                                  }
                                  autoUpload={false}
                                  disabled={
                                    schemas.forms.buttonRequestInstallmentPayment.attachFiles
                                      .disabled
                                  }
                                  fileListVisible={true}
                                  listType="picture-text"
                                  fileList={props.value || []}
                                  onChange={(fileList) => {
                                    if (isEmpty(fileList)) {
                                      props.onChange(undefined)
                                    } else {
                                      let file = fileList[fileList.length - 1]

                                      if (
                                        file.blobFile.size >
                                        (schemas?.attachFiles?.fileSize || defaultMaxFileSize) *
                                          1024 *
                                          1024
                                      ) {
                                        notification.open('error', {
                                          title: `ขนาดไฟล์เกิน ${
                                            schemas.forms.buttonRequestInstallmentPayment
                                              .attachFiles.fileSize || defaultMaxFileSize
                                          } MB`,
                                          duration: 5000,
                                        })
                                        return
                                      }

                                      if (isImageOrPdf(file.blobFile.type)) {
                                        props.onChange(fileList)
                                        setFileTypeError(false)
                                      } else {
                                        setFileTypeError(true)
                                        notification.open('error', {
                                          title:
                                            'ชนิดที่รองรับ ' +
                                              schemas.forms.buttonRequestInstallmentPayment
                                                .attachFiles.fileType || '.jpg, .jpeg, .png, .pdf',
                                          duration: 5000,
                                        })
                                      }
                                    }
                                  }}
                                  draggable
                                >
                                  <div>
                                    <div
                                      style={{ lineHeight: '50px' }}
                                      className={classNames('uploader', `${theme[0]}-background`)}
                                    >
                                      <Icon size="4x" icon="upload2" />
                                      <small className="uploder__text">
                                        <p
                                          style={{ wordBreak: 'break-word' }}
                                          dangerouslySetInnerHTML={{
                                            __html: `คลิกหรือลากไฟล์มายังพื้นที่นี้เพื่ออัปโหลด ชนิดที่รองรับ : .jpg, .jpeg, .png, .pdf <b>ขนาดไม่เกิน 20 Mb</b>`,
                                          }}
                                        />
                                      </small>
                                    </div>
                                  </div>
                                </Uploader>
                              )
                            }}
                          />
                        </Col>
                        <Col lg={2} md={2} sm={2} xs={2}></Col>
                      </Row>

                      {schemas?.forms?.buttonRequestInstallmentPayment?.attachFiles?.values
                        ?.length > 0 && (
                        <Row style={{ marginTop: 20 }}>
                          <Col lg={2} md={2} sm={2} xs={2}></Col>
                          <Col lg={20} md={20} sm={20} xs={20}>
                            <SubProjectViewFilesWidget
                              files={
                                schemas.forms.buttonRequestInstallmentPayment.attachFiles?.values ||
                                []
                              }
                              stringFilesIsNull={`...${schemas.forms.buttonRequestInstallmentPayment.attachFiles.header}...`}
                              buttonEye
                              buttonDownload
                              onPreviewFile={handlePreviewFile}
                              onDownloadFile={handleDownloadFile}
                              viewMode
                            />
                          </Col>
                          <Col lg={2} md={2} sm={2} xs={2}></Col>
                        </Row>
                      )}
                    </>
                  )}
                </>
              )}
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button onClick={handleSubmit(onSubmitRequestInstallmentPayment)} appearance="primary">
              ยืนยัน
            </Button>
            <Button
              onClick={() => {
                setShowWithdrawConfirm(false)
              }}
              appearance="subtle"
              style={{ backgroundColor: '#EEB187', color: '#fff' }}
            >
              ยกเลิก
            </Button>
          </Modal.Footer>
        </Modal>

        {/* อนุมัติเบิกเงินงวด */}
        <Modal
          show={showApproveConfirm}
          onHide={() => {
            // setShowVerifyConfirm(false)
            // setShowTransferInstallmentPaymentConfirm(false)
            setShowApproveConfirm(false)
          }}
          size="lg"
        >
          <Modal.Header>
            <Modal.Title></Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div style={{ padding: 30 }}>
              {schemas.forms.buttonApproveInstallmentPayment && (
                <>
                  {schemas.isNotReportsProgress != 1 && (
                    <>
                      <Row style={{ marginTop: 40 }}>
                        <Col lg={2} md={2} sm={2} xs={2}></Col>
                        <Col lg={20} md={20} sm={20} xs={20}>
                          <b>{schemas.forms.buttonApproveInstallmentPayment.approveType.label}</b>
                        </Col>
                      </Row>
                      <Row>
                        <Col lg={2} md={2} sm={2} xs={2}></Col>
                        <Col lg={20} md={20} sm={20} xs={20}>
                          {/* {show && <Message showIcon type="error" description="กรุณาเลือก 1 รายการ" />} */}
                          <ErrorMessage
                            error={
                              errors[schemas.forms.buttonApproveInstallmentPayment.approveType.name]
                            }
                          />

                          <Controller
                            name={schemas.forms.buttonApproveInstallmentPayment.approveType.name}
                            control={control}
                            defaultValue={
                              schemas.forms.buttonApproveInstallmentPayment.approveType.value || ''
                            }
                            rules={isValidators(
                              schemas.forms.buttonApproveInstallmentPayment.approveType.validators
                            )}
                            render={(props) => {
                              return (
                                <RadioGroup
                                  value={props.value}
                                  onChange={(value) => {
                                    props.onChange(value)
                                  }}
                                >
                                  {schemas.forms.buttonApproveInstallmentPayment.approveType.options.map(
                                    (item) => (
                                      <Radio
                                        key={item.value}
                                        value={item.value}
                                        disabled={
                                          schemas.forms.buttonApproveInstallmentPayment.approveType
                                            .disabled
                                        }
                                      >
                                        {item.label}
                                      </Radio>
                                    )
                                  )}
                                </RadioGroup>
                              )
                            }}
                          />
                        </Col>
                        <Col lg={2} md={2} sm={2} xs={2}></Col>
                      </Row>

                      <Row style={{ marginTop: 10 }}>
                        <Col lg={2} md={2} sm={2} xs={2}></Col>
                        <Col lg={20} md={20} sm={20} xs={20}>
                          <b>
                            {schemas.forms.buttonApproveInstallmentPayment.financialSigning.label}
                          </b>
                        </Col>
                      </Row>
                      <Row>
                        <Col lg={2} md={2} sm={2} xs={2}></Col>
                        <Col lg={20} md={20} sm={20} xs={20}>
                          {show && (
                            <Message showIcon type="error" description="กรุณาเลือก 1 รายการ" />
                          )}

                          <Controller
                            name={
                              schemas.forms.buttonApproveInstallmentPayment.financialSigning.name
                            }
                            control={control}
                            defaultValue={
                              schemas.forms.buttonApproveInstallmentPayment.financialSigning
                                .value || ''
                            }
                            rules={isValidators(
                              schemas.forms.buttonApproveInstallmentPayment.financialSigning
                                .validators
                            )}
                            render={(props) => {
                              return (
                                <RadioGroup
                                  value={props.value}
                                  onChange={(value) => {
                                    props.onChange(value)
                                    setElectronicSignature(value)
                                  }}
                                >
                                  {schemas.forms.buttonApproveInstallmentPayment.financialSigning.options.map(
                                    (item) => (
                                      <Radio
                                        key={item.value}
                                        value={item.value}
                                        disabled={
                                          schemas.forms.buttonApproveInstallmentPayment
                                            .financialSigning.disabled
                                        }
                                      >
                                        {item.label}
                                      </Radio>
                                    )
                                  )}
                                </RadioGroup>
                              )
                            }}
                          />
                        </Col>
                        <Col lg={2} md={2} sm={2} xs={2}></Col>
                      </Row>
                    </>
                  )}
                  <Row style={{ marginTop: 20 }}>
                    <Col lg={2} md={2} sm={2} xs={2}></Col>
                    <Col lg={20} md={20} sm={20} xs={20}>
                      <InputForm
                        schema={schemas.forms.buttonApproveInstallmentPayment.notedInput}
                        // value={item.link}
                        register={register}
                        // placeholder={schemas.otherExpensesInput.placeholder}
                        Controller={Controller}
                        control={control}
                        errors={errors}
                        setValue={setValue}
                        clearErrors={clearErrors}
                        // hideLabel={true}
                        componentClass={'textarea'}
                      />
                    </Col>
                    <Col lg={2} md={2} sm={2} xs={2}></Col>
                  </Row>
                  {schemas?.forms?.buttonRequestInstallmentPayment?.attachFiles?.values?.length >
                    0 && (
                    <Row style={{ marginTop: 20 }}>
                      <Col lg={2} md={2} sm={2} xs={2}></Col>
                      <Col lg={20} md={20} sm={20} xs={20}>
                        <SubProjectViewFilesWidget
                          files={
                            schemas.forms.buttonRequestInstallmentPayment.attachFiles?.values || []
                          }
                          stringFilesIsNull={`...${schemas.forms.buttonRequestInstallmentPayment.attachFiles.buttonText}...`}
                          buttonEye
                          buttonDownload
                          onPreviewFile={handlePreviewFile}
                          onDownloadFile={handleDownloadFile}
                          viewMode
                        />
                      </Col>
                      <Col lg={2} md={2} sm={2} xs={2}></Col>
                    </Row>
                  )}
                </>
              )}
            </div>
          </Modal.Body>
          <Modal.Footer>
            {schemas.isNotReportsProgress == 1 && (
              <Button
                onClick={handleSubmit(onSubmitApproveInstallmentPayment)}
                appearance="primary"
              >
                บันทึก
              </Button>
            )}

            {electronicSignature == '1' && (
              <Button
                onClick={handleSubmit(onSubmitApproveInstallmentPayment)}
                appearance="primary"
              >
                บันทึก
              </Button>
            )}

            {electronicSignature == '2' && (
              <Button
                onClick={handleSubmit(onSubmitApproveInstallmentPayment)}
                appearance="primary"
                className="bt-gost-icon-radius-info"
              >
                ส่งลงนามอิเล็กทรอนิกส์
              </Button>
            )}

            <Button
              onClick={() => {
                setShowApproveConfirm(false)
              }}
              appearance="subtle"
              style={{ backgroundColor: '#EEB187', color: '#fff' }}
            >
              ยกเลิก
            </Button>
          </Modal.Footer>
        </Modal>

        {/* โอนจ่ายเงินงวด */}
        <Modal
          show={showTransferInstallmentPaymentConfirm}
          onHide={() => {
            // setShowVerifyConfirm(false)
            setShowTransferInstallmentPaymentConfirm(false)
          }}
          size="lg"
        >
          <Modal.Header>
            <Modal.Title>{schemas?.forms?.attachFiles?.header || ''}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div style={{ padding: 30 }}>
              {schemas?.forms?.attachFiles && (
                <Row style={{ marginTop: 40 }}>
                  <Col lg={2} md={2} sm={2} xs={2}></Col>
                  <Col lg={20} md={20} sm={20} xs={20}>
                    <ErrorMessage error={errors[schemas.forms.attachFiles.name]} />
                    <Controller
                      key={schemas.forms.attachFiles.name}
                      name={schemas.forms.attachFiles.name}
                      control={control}
                      rules={isValidators(schemas.forms.attachFiles.validators)}
                      defaultValue={''}
                      render={(props) => {
                        return (
                          <Uploader
                            accept={schemas.forms.attachFiles.fileType || '.jpg, .jpeg, .png, .pdf'}
                            autoUpload={false}
                            disabled={schemas.forms.attachFiles.disabled}
                            fileListVisible={true}
                            listType="picture-text"
                            fileList={props.value || []}
                            onChange={(fileList) => {
                              if (isEmpty(fileList)) {
                                props.onChange(undefined)
                              } else {
                                let file = fileList[fileList.length - 1]

                                if (
                                  file.blobFile.size >
                                  (schemas?.attachFiles?.fileSize || defaultMaxFileSize) *
                                    1024 *
                                    1024
                                ) {
                                  notification.open('error', {
                                    title: `ขนาดไฟล์เกิน ${
                                      schemas.forms.attachFiles.fileSize || defaultMaxFileSize
                                    } MB`,
                                    duration: 5000,
                                  })
                                  return
                                }

                                if (isImageOrPdf(file.blobFile.type)) {
                                  props.onChange(fileList)
                                  setFileTypeError(false)
                                } else {
                                  setFileTypeError(true)
                                  notification.open('error', {
                                    title:
                                      'ชนิดที่รองรับ ' + schemas.forms.attachFiles.fileType ||
                                      '.jpg, .jpeg, .png, .pdf',
                                    duration: 5000,
                                  })
                                }
                              }
                            }}
                            draggable
                          >
                            <div>
                              <div
                                style={{ lineHeight: '50px' }}
                                className={classNames('uploader', `${theme[0]}-background`)}
                              >
                                <Icon size="4x" icon="upload2" />
                                <small className="uploder__text">
                                  <p
                                    style={{ wordBreak: 'break-word' }}
                                    dangerouslySetInnerHTML={{
                                      __html: `คลิกหรือลากไฟล์มายังพื้นที่นี้เพื่ออัปโหลด ชนิดที่รองรับ : .jpg, .jpeg, .png, .pdf <b>ขนาดไม่เกิน 20 Mb</b>`,
                                    }}
                                  />
                                </small>
                              </div>
                            </div>
                          </Uploader>
                        )
                      }}
                    />
                  </Col>
                  <Col lg={2} md={2} sm={2} xs={2}></Col>
                </Row>
              )}
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button
              // onClick={() => {
              //   setShowTransferInstallmentPaymentConfirm(false)
              // }}
              onClick={handleSubmit(onSubmitTranInstallPayment)}
              appearance="primary"
            >
              ยืนยัน
            </Button>
            <Button
              onClick={() => {
                setShowTransferInstallmentPaymentConfirm(false)
              }}
              appearance="subtle"
              style={{ backgroundColor: '#EEB187', color: '#fff' }}
            >
              ยกเลิก
            </Button>
          </Modal.Footer>
        </Modal>

        {/* ส่งกลับแก้ไข */}
        <Modal
          show={showVerifyConfirm}
          onHide={() => {
            setShowVerifyConfirm(false)
          }}
        >
          <Modal.Header>
            <Modal.Title>
              <div style={{ padding: 5 }}>{schemas.forms.notedInput.label}</div>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div style={{ padding: 30 }}>
              <InputForm
                schema={schemas.forms.notedInput}
                // value={item.link}
                register={register}
                // placeholder={schemas.otherExpensesInput.placeholder}
                Controller={Controller}
                control={control}
                errors={errors}
                setValue={setValue}
                clearErrors={clearErrors}
                hideLabel={true}
                componentClass={'textarea'}
              />
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button onClick={handleSubmit(onSubmitSendBlack)} appearance="primary">
              ยืนยัน
            </Button>
            <Button
              onClick={() => {
                setShowVerifyConfirm(false)
              }}
              appearance="subtle"
              style={{ backgroundColor: '#EEB187', color: '#fff' }}
            >
              ยกเลิก
            </Button>
          </Modal.Footer>
        </Modal>
      </SidebarProposal>
    </>
  )
}

const mockSchema = {
  header: 'รายงานการเงินงวดปิด',
  subHeader: 'รหัสโครงการ 65-10063-01 : รณรงลดโรค ลดโควิด 09/01',
  forms: {
    projectActivity: {
      header: 'ส่วนที่ 1 แบบแจกแจงรายจ่ายแยกตามกิจกรรมโครงการ',
      // taxBankInput: {
      //   name: 'taxBankInput',
      //   label: 'ภาษีดอกเบี้ยรับธนาคาร (ถ้ามี)',
      //   unit: 'บาท',
      //   value: '',
      //   validators: null,
      // },
      // otherExpensesInput: {
      //   name: 'otherExpensesInput',
      //   label: 'ค่าใช้จ่ายอื่นๆ (ถ้ามี)',
      //   placeholder: '- ระบุ -',
      //   value: '',
      //   validators: null,
      // },
      withdrawInput: {
        name: 'withdrawInput',
        label: 'ถอนเงินเปิดบัญชีธนาคาร',
        placeholder: '0.00',
        value: '0.00',
        unit: 'บาท',
        validators: null,
      },
      // otherExpensesPriceInput: {
      //   name: 'otherExpensesPriceInput',
      //   label: '',
      //   value: '',
      //   unit: 'บาท',
      //   validators: null,
      // },
      values: [
        {
          id: 'xxxx-xxxx-01',
          activity: 'กิจกรรมที่ 1',
          compensation: 1500, //ค่าตอบแทน
          wages: 900, //ค่าจ้าง
          expenses: 18200, //ค่าใช้สอย
          materialCost: 700, //ค่าวัสดุ
          utilityCosts: 550, //ค่าสาธารณูปโภค
          otherExpenses: 1200, //รายจ่ายอื่นๆ
          total: 23050,
        },
        {
          id: 'xxxx-xxxx-02',
          activity: 'กิจกรรมที่ 2',
          compensation: 2000, //ค่าตอบแทน
          wages: 3000, //ค่าจ้าง
          expenses: 2000, //ค่าใช้สอย
          materialCost: 2000, //ค่าวัสดุ
          utilityCosts: 0, //ค่าสาธารณูปโภค
          otherExpenses: 0, //รายจ่ายอื่นๆ
          total: 9000,
        },
        {
          id: 'xxxx-xxxx-03',
          activity: 'กิจกรรมที่ 3',
          compensation: 18000, //ค่าตอบแทน
          wages: 0, //ค่าจ้าง
          expenses: 2000, //ค่าใช้สอย
          materialCost: 0, //ค่าวัสดุ
          utilityCosts: 0, //ค่าสาธารณูปโภค
          otherExpenses: 0, //รายจ่ายอื่นๆ
          total: 20000,
        },
        {
          id: 'total',
          activity: '',
          compensation: 21500, //ค่าตอบแทน
          wages: 3900, //ค่าจ้าง
          expenses: 22200, //ค่าใช้สอย
          materialCost: 2700, //ค่าวัสดุ
          utilityCosts: 550, //ค่าสาธารณูปโภค
          otherExpenses: 1200, //รายจ่ายอื่นๆ
          total: 52050,
        },
      ],
    },
    summaryPeriodicExpenses: {
      header: 'ส่วนที่ 2 แบบรายงานสรุปการใช้จ่ายเงินประจำงวดนี้',
      income: {
        title: '1. รายรับ',
        input: [
          {
            name: 'carryingBalance',
            label: 'เงินคงเหลือยกมา (ถ้ามี)',
            value: '0.00',
            unit: 'บาท',
            placeholder: '0.00',
            disable: true,
            validators: null,
            information: null,
          },
          {
            name: 'ssoBalance',
            label: 'เงินรับจาก สสส. งวด นี้',
            value: '50000.00',
            unit: 'บาท',
            placeholder: '0.00',
            disable: true,
            validators: null,
            information: null,
          },
          {
            name: 'interestReceivable',
            label: 'ดอกเบี้ยรับ',
            value: '0.00',
            unit: 'บาท',
            placeholder: '0.00',
            disable: false,
            validators: null,
            information: null,
          },
          {
            name: 'bankAccOpeningMoney',
            label: 'เงินเปิดบัญชีธนาคาร',
            value: '0.00',
            unit: 'บาท',
            placeholder: '0.00',
            disable: false,
            validators: null,
            information: null,
          },
          {
            name: 'total',
            label: 'รวมรายรับ',
            value: '0.00',
            unit: 'บาท',
            placeholder: '0.00',
            disable: false,
            validators: null,
            information: null,
          },
        ],
      },
      expenses: {
        title: '2. รายจ่าย',
        input: [
          {
            name: 'periodNegativeBalance',
            label: 'ยอดติดลบงวดก่อนหน้ายกมา (ถ้ามี)',
            value: '0.00',
            unit: 'บาท',
            placeholder: '0.00',
            disable: true,
            validators: null,
            information: null,
          },
          {
            name: 'activity0',
            label: 'กิจกรรมที่ 1',
            value: '2000.00',
            unit: 'บาท',
            placeholder: '0',
            disable: true,
            validators: null,
            information: null,
          },
          {
            name: 'activity1',
            label: 'กิจกรรมที่ 2',
            value: '1600.00',
            unit: 'บาท',
            placeholder: '0.00',
            disable: true,
            validators: null,
            information: null,
          },
          {
            name: 'activity2',
            label: 'กิจกรรมที่ 3',
            value: '14000.00',
            unit: 'บาท',
            placeholder: '0.00',
            disable: true,
            validators: null,
            information: null,
          },
          // {
          //   name: 'bankInterestTax',
          //   label: 'ภาษีดอกเบี้ยรับธนาคาร',
          //   value: '0.00',
          //   unit: 'บาท',
          //   placeholder: '0.00',
          //   disable: true,
          //   validators: null,
          //   information: null,
          // },
          {
            name: 'withdrawMoneyBankAccount',
            label: 'ถอนเงินเปิดบัญชีธนาคาร',
            value: '0.00',
            unit: 'บาท',
            placeholder: '0.00',
            disable: false,
            validators: null,
            information: null,
          },
          {
            name: 'total',
            label: 'รวมรายจ่าย',
            value: '0.00',
            unit: 'บาท',
            placeholder: '0.00',
            disable: false,
            validators: null,
            information: null,
          },
        ],
      },
      balance: {
        title: '3. คงเหลือ',
        input: [
          {
            name: 'moneyOnhand',
            label: 'เงินสดในมือ',
            value: '0.00',
            unit: 'บาท',
            placeholder: '0.00',
            disable: true,
            validators: null,
            information: null,
          },
          {
            name: 'bankDeposits',
            label: 'เงินฝากในบัญชีธนาคาร',
            value: '0.00',
            unit: 'บาท',
            placeholder: '0.00',
            disable: false,
            validators: null,
            information: 'ยอดเงินสุดท้ายที่ปรากฏในบัญชีธนาคาร',
          },
          {
            name: 'total',
            label: '(1) รายรับ - (2) รายจ่าย = (3)',
            value: '0.00',
            unit: 'บาท',
            placeholder: '0.00',
            disable: false,
            validators: null,
            information: null,
          },
        ],
      },
      attachFiles: {
        name: 'attachFiles',
        header: 'แนบสำเนาสมุดบัญชีเงินฝากธนาคาร',
        buttonText: 'ไฟล์ประกอบการติดตาม',
        fileSize: 50,
        fileType: '.jpg, .jpeg, .png, .pdf',
        description: ['แนบสำเนาสมุดบัญชีเงินฝากธนาคาร'],
        value: [
          {
            seqNo: 1,
            isUpSeqNo: true,
            isDownSeqNo: false,
            label: 'ไฟล์ทดสอบ.png',
            name: 'ไฟล์ทดสอบ.png',
            path: 'proposal/appendix/45CC61FF-C595-4CA3-BAE2-63CC97F315FF.png',
            type: null,
            size: 0,
            id: '030CF477-509D-494A-8226-BF870998E63B',
          },
          {
            seqNo: 1,
            isUpSeqNo: true,
            isDownSeqNo: false,
            label: 'ไฟล์ทดสอบ.png',
            name: 'ไฟล์ทดสอบ.png',
            path: 'proposal/appendix/45CC61FF-C595-4CA3-BAE2-63CC97F315FF.png',
            type: null,
            size: 0,
            id: '030CF477-509D-494A-8226-BF870998E63B',
          },
          {
            seqNo: 1,
            isUpSeqNo: true,
            isDownSeqNo: false,
            label: 'ไฟล์ทดสอบ.png',
            name: 'ไฟล์ทดสอบ.png',
            path: 'proposal/appendix/45CC61FF-C595-4CA3-BAE2-63CC97F315FF.png',
            type: null,
            size: 0,
            id: '030CF477-509D-494A-8226-BF870998E63B',
          },
          {
            seqNo: 1,
            isUpSeqNo: true,
            isDownSeqNo: false,
            label: 'ไฟล์ทดสอบ.png',
            name: 'ไฟล์ทดสอบ.png',
            path: 'proposal/appendix/45CC61FF-C595-4CA3-BAE2-63CC97F315FF.png',
            type: null,
            size: 0,
            id: '030CF477-509D-494A-8226-BF870998E63B',
          },
        ],
        id: null,
      },
    },
    notedInput: {
      name: 'notedInput',
      label: 'กรุณาระบุข้อความเพื่อขอส่งรายงาน และเบิกเงินงวด กับทีมสนับสนุน (ถ้ามี)',
      value: '',
      validators: null,
    },
    button: {
      buttonSave: 'บันทึก',
      buttonApprove: 'ส่งรายการ ขอเบิกเงินงวด',
      buttonSendBlack: null,
    },
  },
}

const mockSchema2 = {
  header: 'รายงานการเงินงวดปิด',
  subHeader: 'รหัสโครงการ 65-10063-01 : รณรงลดโรค ลดโควิด 09/02',
  forms: {
    projectActivity: {
      header: 'ส่วนที่ 1 แบบแจกแจงรายจ่ายแยกตามกิจกรรมโครงการ',
      // taxBankInput: {
      //   name: 'taxBankInput',
      //   label: 'ภาษีดอกเบี้ยรับธนาคาร (ถ้ามี)',
      //   unit: 'บาท',
      //   value: '',
      //   validators: null,
      // },
      // otherExpensesInput: {
      //   name: 'otherExpensesInput',
      //   label: 'ค่าใช้จ่ายอื่นๆ (ถ้ามี)',
      //   placeholder: '- ระบุ -',
      //   value: '',
      //   validators: null,
      // },
      withdrawInput: {
        name: 'withdrawInput',
        label: 'ถอนเงินเปิดบัญชีธนาคาร',
        placeholder: '0.00',
        value: '0.00',
        unit: 'บาท',
        validators: null,
      },
      // otherExpensesPriceInput: {
      //   name: 'otherExpensesPriceInput',
      //   label: '',
      //   value: '',
      //   unit: 'บาท',
      //   validators: null,
      // },
      values: [
        {
          id: 'xxxx-xxxx-01',
          activity: 'กิจกรรมที่ 1',
          compensation: 1500, //ค่าตอบแทน
          wages: 900, //ค่าจ้าง
          expenses: 18200, //ค่าใช้สอย
          materialCost: 700, //ค่าวัสดุ
          utilityCosts: 550, //ค่าสาธารณูปโภค
          otherExpenses: 1200, //รายจ่ายอื่นๆ
          total: 23050,
        },
        {
          id: 'xxxx-xxxx-02',
          activity: 'กิจกรรมที่ 2',
          compensation: 2000, //ค่าตอบแทน
          wages: 3000, //ค่าจ้าง
          expenses: 2000, //ค่าใช้สอย
          materialCost: 2000, //ค่าวัสดุ
          utilityCosts: 0, //ค่าสาธารณูปโภค
          otherExpenses: 0, //รายจ่ายอื่นๆ
          total: 9000,
        },
        {
          id: 'xxxx-xxxx-03',
          activity: 'กิจกรรมที่ 3',
          compensation: 18000, //ค่าตอบแทน
          wages: 0, //ค่าจ้าง
          expenses: 2000, //ค่าใช้สอย
          materialCost: 0, //ค่าวัสดุ
          utilityCosts: 0, //ค่าสาธารณูปโภค
          otherExpenses: 0, //รายจ่ายอื่นๆ
          total: 20000,
        },
        {
          id: 'total',
          activity: '',
          compensation: 21500, //ค่าตอบแทน
          wages: 3900, //ค่าจ้าง
          expenses: 22200, //ค่าใช้สอย
          materialCost: 2700, //ค่าวัสดุ
          utilityCosts: 550, //ค่าสาธารณูปโภค
          otherExpenses: 1200, //รายจ่ายอื่นๆ
          total: 52050,
        },
      ],
    },
    summaryPeriodicExpenses: {
      header: 'ส่วนที่ 2 แบบรายงานสรุปการใช้จ่ายเงินประจำงวดนี้',
      income: {
        title: '1. รายรับ',
        input: [
          {
            name: 'carryingBalance',
            label: 'เงินคงเหลือยกมา (ถ้ามี)',
            value: '0.00',
            unit: 'บาท',
            placeholder: '0.00',
            disable: true,
            validators: null,
            information: null,
          },
          {
            name: 'ssoBalance',
            label: 'เงินรับจาก สสส. งวด นี้',
            value: '50000.00',
            unit: 'บาท',
            placeholder: '0.00',
            disable: true,
            validators: null,
            information: null,
          },
          {
            name: 'interestReceivable',
            label: 'ดอกเบี้ยรับ',
            value: '0.00',
            unit: 'บาท',
            placeholder: '0.00',
            disable: false,
            validators: null,
            information: null,
          },
          {
            name: 'bankAccOpeningMoney',
            label: 'เงินเปิดบัญชีธนาคาร',
            value: '0.00',
            unit: 'บาท',
            placeholder: '0.00',
            disable: false,
            validators: null,
            information: null,
          },
          {
            name: 'total',
            label: 'รวมรายรับ',
            value: 'XXX,0000',
            unit: 'บาท',
            placeholder: '0',
            disable: false,
            validators: null,
            information: null,
          },
        ],
      },
      expenses: {
        title: '2. รายจ่าย',
        input: [
          {
            name: 'periodNegativeBalance',
            label: 'ยอดติดลบงวดก่อนหน้ายกมา (ถ้ามี)',
            value: '0.00',
            unit: 'บาท',
            placeholder: '0.00',
            disable: true,
            validators: null,
            information: null,
          },
          {
            name: 'activity0',
            label: 'กิจกรรมที่ 1',
            value: '2000.00',
            unit: 'บาท',
            placeholder: '0',
            disable: true,
            validators: null,
            information: null,
          },
          {
            name: 'activity1',
            label: 'กิจกรรมที่ 2',
            value: '1600.00',
            unit: 'บาท',
            placeholder: '0.00',
            disable: true,
            validators: null,
            information: null,
          },
          {
            name: 'activity2',
            label: 'กิจกรรมที่ 3',
            value: '14000.00',
            unit: 'บาท',
            placeholder: '0.00',
            disable: true,
            validators: null,
            information: null,
          },
          // {
          //   name: 'bankInterestTax',
          //   label: 'ภาษีดอกเบี้ยรับธนาคาร',
          //   value: '0.00',
          //   unit: 'บาท',
          //   placeholder: '0.00',
          //   disable: true,
          //   validators: null,
          //   information: null,
          // },
          {
            name: 'withdrawMoneyBankAccount',
            label: 'ถอนเงินเปิดบัญชีธนาคาร',
            value: '0.00',
            unit: 'บาท',
            placeholder: '0.00',
            disable: false,
            validators: null,
            information: null,
          },
          {
            name: 'total',
            label: 'รวมรายจ่าย',
            value: '0.00',
            unit: 'บาท',
            placeholder: '0.00',
            disable: false,
            validators: null,
            information: null,
          },
        ],
      },
      balance: {
        title: '3. คงเหลือ',
        input: [
          {
            name: 'moneyOnhand',
            label: 'เงินสดในมือ',
            value: '0.00',
            unit: 'บาท',
            placeholder: '0.00',
            disable: true,
            validators: null,
            information: null,
          },
          {
            name: 'bankDeposits',
            label: 'เงินฝากในบัญชีธนาคาร',
            value: '0.00',
            unit: 'บาท',
            placeholder: '0.00',
            disable: false,
            validators: null,
            information: 'ยอดเงินสุดท้ายที่ปรากฏในบัญชีธนาคาร',
          },
          {
            name: 'total',
            label: '(1) รายรับ - (2) รายจ่าย = (3)',
            value: '0.00',
            unit: 'บาท',
            placeholder: '0.00',
            disable: false,
            validators: null,
            information: null,
          },
        ],
      },
      attachFiles: {
        name: 'attachFiles',
        header: 'แนบสำเนาสมุดบัญชีเงินฝากธนาคาร',
        buttonText: 'ไฟล์ประกอบการติดตาม',
        fileSize: 50,
        fileType: '.jpg, .jpeg, .png, .pdf',
        description: ['แนบสำเนาสมุดบัญชีเงินฝากธนาคาร'],
        value: [
          {
            seqNo: 1,
            isUpSeqNo: true,
            isDownSeqNo: false,
            label: 'ไฟล์ทดสอบ.png',
            name: 'ไฟล์ทดสอบ.png',
            path: 'proposal/appendix/45CC61FF-C595-4CA3-BAE2-63CC97F315FF.png',
            type: null,
            size: 0,
            id: '030CF477-509D-494A-8226-BF870998E63B',
          },
          {
            seqNo: 1,
            isUpSeqNo: true,
            isDownSeqNo: false,
            label: 'ไฟล์ทดสอบ.png',
            name: 'ไฟล์ทดสอบ.png',
            path: 'proposal/appendix/45CC61FF-C595-4CA3-BAE2-63CC97F315FF.png',
            type: null,
            size: 0,
            id: '030CF477-509D-494A-8226-BF870998E63B',
          },
          {
            seqNo: 1,
            isUpSeqNo: true,
            isDownSeqNo: false,
            label: 'ไฟล์ทดสอบ.png',
            name: 'ไฟล์ทดสอบ.png',
            path: 'proposal/appendix/45CC61FF-C595-4CA3-BAE2-63CC97F315FF.png',
            type: null,
            size: 0,
            id: '030CF477-509D-494A-8226-BF870998E63B',
          },
          {
            seqNo: 1,
            isUpSeqNo: true,
            isDownSeqNo: false,
            label: 'ไฟล์ทดสอบ.png',
            name: 'ไฟล์ทดสอบ.png',
            path: 'proposal/appendix/45CC61FF-C595-4CA3-BAE2-63CC97F315FF.png',
            type: null,
            size: 0,
            id: '030CF477-509D-494A-8226-BF870998E63B',
          },
        ],
        id: null,
      },
    },
    notedInput: {
      name: 'notedInput',
      label: 'กรุณาระบุข้อความเพื่อส่งกลับแก้ไข',
      value: '',
      validators: null,
    },
    attachFiles: {
      name: 'attachFiles',
      header: 'กรุณาแนบเอกสารประกอบโอนเงิน',
      buttonText: 'ไฟล์เอกสารประกอบโอนเงิน',
      fileSize: 50,
      fileType: '.jpg, .jpeg, .png, .pdf',
      description: ['แนบเอกสารประกอบโอนเงิน'],
      value: [
        {
          seqNo: 1,
          isUpSeqNo: true,
          isDownSeqNo: false,
          label: 'ไฟล์ทดสอบ.png',
          name: 'ไฟล์ทดสอบ.png',
          path: 'proposal/appendix/45CC61FF-C595-4CA3-BAE2-63CC97F315FF.png',
          type: null,
          size: 0,
          id: '030CF477-509D-494A-8226-BF870998E63B',
        },
        {
          seqNo: 1,
          isUpSeqNo: true,
          isDownSeqNo: false,
          label: 'ไฟล์ทดสอบ.png',
          name: 'ไฟล์ทดสอบ.png',
          path: 'proposal/appendix/45CC61FF-C595-4CA3-BAE2-63CC97F315FF.png',
          type: null,
          size: 0,
          id: '030CF477-509D-494A-8226-BF870998E63B',
        },
      ],
      id: null,
    },
    buttonApproveInstallmentPayment: {
      notedInput: {
        name: 'notedInput',
        label: 'ความเห็นเพิ่มเติมอื่นๆ',
        value: '',
        validators: [
          {
            type: 'REQUIRED',
            value: null,
            errorMessage: 'กรุณากรอกลักษณะนวัตกรรม',
          },
        ],
      },
      approveType: {
        name: 'approveType',
        label: 'ความเห็นต่อคำขอเบิกเงินงวด',
        value: '',
        options: [
          {
            disabled: false,
            label: 'เห็นควรเบิกจ่ายเงินงวดถัดไป',
            value: 1,
          },
          {
            disabled: false,
            label: 'เห็นควรเบิกจ่ายเงินงวดและปิดโครงการ',
            value: 2,
          },
          {
            disabled: false,
            label: 'เห็นควรเบิกจ่ายเงินงวดและยุติโครงการ',
            value: 3,
          },
        ],
        validators: [
          {
            type: 'REQUIRED',
            value: null,
            errorMessage: 'กรุณากรอก',
          },
        ],
      },
      financialSigning: {
        name: 'financialSigning',
        label: 'การลงนามในรายงานการเงิน',
        value: '',
        options: [
          {
            disabled: false,
            label: 'แบบกระดาษ',
            value: 1,
          },
          {
            disabled: false,
            label: 'แบบอิเล็กทรอนิกส์',
            value: 2,
          },
        ],
        validators: [
          {
            type: 'REQUIRED',
            value: null,
            errorMessage: 'กรุณากรอก',
          },
        ],
      },
    },
    buttonRequestInstallmentPayment: {
      notedInput: {
        name: 'notedInput',
        label: 'ความเห็นเพิ่มเติมอื่นๆ',
        value: '',
        validators: [
          {
            type: 'REQUIRED',
            value: null,
            errorMessage: 'กรุณากรอกความเห็นเพิ่มเติมอื่นๆ',
          },
        ],
      },
      approveType: {
        name: 'approveType',
        label: 'ความเห็นต่อคำขอเบิกเงินงวด',
        value: '',
        options: [
          {
            disabled: false,
            label: 'เห็นควรเบิกจ่ายเงินงวดถัดไป',
            value: 1,
          },
          {
            disabled: false,
            label: 'เห็นควรเบิกจ่ายเงินงวดและปิดโครงการ',
            value: 2,
          },
          {
            disabled: false,
            label: 'เห็นควรเบิกจ่ายเงินงวดและยุติโครงการ',
            value: 3,
          },
        ],
        validators: [
          {
            type: 'REQUIRED',
            value: null,
            errorMessage: 'กรุณากรอก',
          },
        ],
      },
      financialSigning: {
        name: 'financialSigning',
        label: 'การลงนามในรายงานการเงิน',
        value: '',
        options: [
          {
            disabled: false,
            label: 'แบบกระดาษ',
            value: 1,
          },
          {
            disabled: false,
            label: 'แบบอิเล็กทรอนิกส์',
            value: 2,
          },
        ],
        validators: [
          {
            type: 'REQUIRED',
            value: null,
            errorMessage: 'กรุณากรอก',
          },
        ],
      },
      attachFiles: {
        name: 'attachFiles',
        header: 'กรุณาแนบเอกสารประกอบขอเบิกเงินงวด',
        buttonText: 'ไฟล์เอกสารประกอบขอเบิกเงินงวด',
        fileSize: 50,
        fileType: '.jpg, .jpeg, .png, .pdf',
        description: ['แนบเอกสารประกอบขอเบิกเงินงวด'],
        value: [
          {
            seqNo: 1,
            isUpSeqNo: true,
            isDownSeqNo: false,
            label: 'ไฟล์ทดสอบ.png',
            name: 'ไฟล์ทดสอบ.png',
            path: 'proposal/appendix/45CC61FF-C595-4CA3-BAE2-63CC97F315FF.png',
            type: null,
            size: 0,
            id: '030CF477-509D-494A-8226-BF870998E63B',
          },
        ],
        id: null,
      },
    },
    button: {
      buttonSave: null,
      buttonApprove: null,
      buttonRequestInstallmentPayment: 'ส่งรายงานขอเบิกเงินงวด',
      buttonApproveInstallmentPayment: 'อนุมัติเบิกเงินงวด',
      buttonTransferInstallmentPayment: 'โอนจ่ายเงินงวด',
      buttonSendBlack: 'ส่งกลับแก้ไข',
    },
  },
}
